export default __webpack_public_path__ + "static/media/2.48b08e89.png";